dmx.Component('stripe-au-bank-account', {

    initialData: {
        complete: false,
        empty: true,
        bankName: '',
        branchName: '',
        error: undefined,
        source: undefined,
        paymentMethod: undefined,
        paymentIntent: undefined,
        setupIntent: undefined
    },

    attributes: {
        'value': {
            type: String,
            default: ''
        },

        'icon-style': {
            type: String,
            default: 'default',
            enum: ['default', 'solid']
        },

        'hide-icon': {
            type: Boolean,
            default: false
        },

        'disabled': {
            type: Boolean,
            default: false
        },

        'hide-errors': {
            type: Boolean,
            default: false
        },

        'accountholder-name': {
            type: String,
            default: ''
        }
    },

    methods: {
        blur: function() {
            if (this.instance) {
                this.element.blur();
            }
        },

        clear: function() {
            if (this.instance) {
                this.element.clear();
            }
        },

        focus: function() {
            if (this.instance) {
                this.element.focus();
            }
        },

        createSource: function(data) {
            if (this.instance) {
                var self = this;
                return dmx.stripe.instance.createSource(this.element, data).then(function(result) {
                    if (result.error) {
                        self.set('error', result.error);
                        self.dispatchEvent('error');
                    } else {
                        self.set('source', result.source);
                        self.dispatchEvent('source_created');
                    }
                    return result;
                });
            }
        },

        createPaymentMethod: function() {
            if (this.instance) {
                var self = this;
                return dmx.stripe.instance.createPaymentMethod({
                    type: 'au_becs_debit',
                    au_becs_debit: this.element
                }).then(function(result) {
                    if (result.error) {
                        self.set('error', result.error);
                        self.dispatchEvent('error');
                    } else {
                        self.set('paymentMethod', result.paymentMethod);
                        self.dispatchEvent('payment_method_created');
                    }
                    return result;
                });
            }
        },

        confirmPayment: function(clientSecret) {
            if (this.instance) {
                var self = this;
                return dmx.stripe.instance.confirmAuBecsDebitPayment(clientSecret || dmx.stripe.client_secret, {
                    payment_method: {
                        au_becs_debit: this.element,
                        billing_details: {
                            name: this.props['accountholder-name']
                        }
                    }
                }).then(function(result) {
                    if (result.error) {
                        self.set('error', result.error);
                        self.dispatchEvent('error');
                    } else {
                        self.set('paymentIntent', result.paymentIntent);
                        self.dispatchEvent('payment_confirmed');
                    }
                    return result;
                });
            }
        },

        confirmSetup: function(clientSecret) {
            if (this.instance) {
                var self = this;
                return dmx.stripe.instance.confirmAuBecsDebitSetup(clientSecret || dmx.stripe.client_secret, {
                    payment_method: {
                        au_becs_debit: this.element,
                        billing_details: {
                            name: this.props['accountholder-name']
                        }
                    }
                }).then(function(result) {
                    if (result.error) {
                        self.set('error', result.error);
                        self.dispatchEvent('error');
                    } else {
                        self.set('setupIntent', result.setupIntent);
                        self.dispatchEvent('setup_confirmed');
                    }
                    return result;
                });
            }
        }
    },

    events: {
        change: Event,
        ready: Event,
        focus: Event,
        blur: Event,
        escape: Event,
        error: Event,
        source_created: Event,
        payment_method_created: Event,
        payment_confirmed: Event,
        setup_confirmed: Event
    },

    onchange: function(event) {
        this.set(event);

        if (!this.props['hide-errors']) {
            this.errorElement.textContent = event.error ? event.error.message : '';
        }
    },

    render: function(node) {
        var self = this;
        dmx.stripe.ready(function(stripe) {
            var theme = dmx.stripe.theme[window.bootstrap ? 'bootstrap' : 'default'];

            self.element = dmx.stripe.elements.create('auBankAccount', {
                value: self.props['value'],
                iconStyle: self.props['icon-style'],
                hideIcon: self.props['hide-icon'],
                disabled: self.props['disabled'],
                classes: theme.classes,
                style: theme.style
            });

            self.element.mount(node);

            self.errorElement = document.createElement('div');
            self.errorElement.className = theme.error.class;

            node.insertAdjacentElement('afterend', self.errorElement);

            self.element.on('change', self.onchange.bind(self));
            self.element.on('change', self.dispatchEvent.bind(self, 'change'));
            self.element.on('ready', self.dispatchEvent.bind(self, 'ready'));
            self.element.on('focus', self.dispatchEvent.bind(self, 'focus'));
            self.element.on('blur', self.dispatchEvent.bind(self, 'blur'));
            self.element.on('escape', self.dispatchEvent.bind(self, 'escape'));
        });
    },

    update: function(props) {
        if (this.instance) {
            if (this.props['value'] != props['value']) {
                this.element.update({ value: this.props['value'] });
            }

            if (this.props['icon-style'] != props['icon-style']) {
                this.element.update({ iconStyle: this.props['icon-style'] });
            }

            if (this.props['hide-icon'] != props['hide-icon']) {
                this.element.update({ hideIcon: this.props['hide-icon'] });
            }

            if (this.props['disabled'] != props['disabled']) {
                this.element.update({ disabled: this.props['disabled'] });
            }
        }
    },

    destroy: function() {
        if (this.element) {
            this.element.destroy();
        }
    }

});